var _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftHalfCircle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 161,
    height: 161,
    viewBox: "0 0 161 161",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 45.1989,
    cy: 45.1987,
    r: 114.917,
    fill: "#F8A63F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftHalfCircle);
export default __webpack_public_path__ + "static/media/left-half-circle.f6a0f484421ae65d9ab30d3df6ce914d.svg";
export { ForwardRef as ReactComponent };